"use client";
import { useAppContext } from "@/providers/AppProvider";
import { Moon, Sun } from "lucide-react";

function ThemeSwitchButton() {
    const { theme, toggleTheme } = useAppContext();

    return (
        <button
            onClick={toggleTheme}
            className="absolute right-3 top-3 rounded-full p-2 outline-none transition hover:text-primary"
            aria-label="Toggle Theme"
        >
            {theme === "light" ? (
                <Moon className="h-5 w-5" />
            ) : (
                <Sun className="h-5 w-5" />
            )}
        </button>
    );
}

export default ThemeSwitchButton;
